/* Slider News - page accueil */
$('.news-slider.news-slider--desktop-mode').flickity({
    autoPlay: 3200,
    pauseAutoPlayOnHover: true,
    cellSelector: '.news-slider__slide',
    cellAlign: 'center',
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    freeScroll: true
});